import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import styled from 'styled-components';

// Importação dos componentes
import Header from './components/Header';
import Footer from './components/Footer';
import Hero from './components/Hero';
import Services from './components/Services';
import Facility from './components/Facility';
import Testimonials from './components/Testimonials';
import AboutUs from './components/AboutUs';
import TeamMembers from './components/TeamMembers';
import Contact from './components/Contact';

// Estilos globais
const GlobalStyle = styled.div`
  font-family: 'Poppins', sans-serif;
  color: #333;
  
  * {
    box-sizing: border-box;
    margin: 0;
    padding: 0;
  }
`;

function App() {
  return (
    <Router>
      <GlobalStyle>
        <Header />
        <Routes>
          <Route path="/" element={
            <>
              <Hero />
              <Services />
              <Facility />
              <Testimonials />
              <AboutUs />
              <TeamMembers />
              <Contact />
            </>
          } />
          {/* Rotas adicionais podem ser adicionadas aqui */}
        </Routes>
        <Footer />
      </GlobalStyle>
    </Router>
  );
}

export default App;
